// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__o8NEe","disabled":"styles_disabled__zWFOh","circularProgress":"styles_circularProgress__YdX3O","link":"styles_link__scPBL"};